import { getGlobal } from "../global";

/**
 * Logging levels. Higher number means more verbose logs,
 * for example, with level 3, `info`, `warn`, or `error`
 * logs will show up in the console but `debug` and `log` won't.
 *
 * Semantics of specific levels:
 *  - debug: low-level debugging logs
 *  - log: common, higher-level debugging logs
 *  - info: helpful runtime information (even for stag/prod environments)
 *  - warn: potentially problematic situations; handled exceptions
 *  - error: definitely problematic situations; unhandled exceptions
 * @readonly
 * @enum {number}
 */
export const LogLevels = {
  DEBUG: 5,
  LOG: 4,
  INFO: 3,
  WARNING: 2,
  ERROR: 1,
  NONE: 0
};


/**
 * Logger class.
 * Depending on options.logLevel setting in initilize function, corresponding functions would be activated.
 */
class NoOpLogger {

  level = LogLevels.NONE;

  runtimeStats = {};
  environmentInfo = {};

  initialize(options) {
    console.warn(`Logger initialized before one was provided, this is most likely a misconfiguration issue!`);
  }
  shutdown() {}
  track() {}
  updateRuntimeStats() {}
  reportRuntimeStats() {}
  setLevel(level) {
    this.level = isNaN(Number(level)) ? this.level : level;
  }
  _reportError() {}
  debug() {}
  log() {}
  info() {}
  warn() {}
  error() {}
}


export let logger = new NoOpLogger();

export function setLogger(l) {
  if (!l) {
    // Prevent null/undefined errors from global scope access
    l = new NoOpLogger();
  }
  // Preserve the log level from the current logger if it exists
  if (logger.level !== undefined) {
    l.setLevel(logger.level);
  }

  logger = l;
  const avp = getGlobal()?.Autodesk?.Viewing?.Private;
  if (avp) {
    avp.logger = logger;
  }
}